import React from 'react';

interface TintedIconProps {
  src: string;
  alt?: string;
  className?: string;
  isDarkMode?: boolean;
}

/**
 * Image icon with optional dark-mode purple tint — mask keeps transparent pixels clear.
 */
const TintedIcon: React.FC<TintedIconProps> = ({
  src,
  alt = '',
  className = '',
  isDarkMode = false,
}) => (
  <div className={`relative ${className}`} style={{ isolation: 'isolate' }}>
    <img
      src={src}
      alt={alt}
      draggable={false}
      className="block h-full w-full object-contain"
    />
    <div
      aria-hidden
      style={{
        position: 'absolute',
        inset: 0,
        backgroundColor: '#4a2f72',
        mixBlendMode: 'multiply',
        opacity: isDarkMode ? 0.4 : 0,
        transition: 'opacity 0.8s ease-in-out',
        WebkitMaskImage: `url("${src}")`,
        maskImage: `url("${src}")`,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        pointerEvents: 'none',
      }}
    />
  </div>
);

export default TintedIcon;
